import React, { useState, useEffect } from "react";
import { Card, Form, Input, Button, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../redux/store.ts";
import authService from "../../services/auth-service.ts";
import Constant from "../../global/Constant.ts";
import RoutePath from "../../global/RoutePath.ts";
import { setLoading, addNotification } from "../../redux/globalSlice.ts";

const { Title } = Typography;

const OneTimePassword: React.FC = () => {
  const userData = useSelector((state: RootState) => state.auth.userData);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [timer, setTimer] = useState(60);
  const [otpSent, setOtpSent] = useState(true);

  const dispatch = useDispatch();

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      return () => clearInterval(interval);
    } else {
      setOtpSent(false);
    }
  }, [timer]);

  const handleVerifyOTP = async (values: any) => {
    try {
      await authService.signup(Constant.signUp, { ...userData, ...values });

      dispatch(
        addNotification({
          title: "Success",
          description: "OTP verified successfully. Please log in to continue.",
          type: "success",
        })
      );
      navigate(RoutePath.assessmentQuestion);
    } catch (error) {
      form.setFields([
        {
          name: "confirmationCode",
          errors: [
            "Incorrect OTP, Please enter the correct OTP or request a new one",
          ],
        },
      ]);
    }
  };

  const handleResendOTP = async () => {
    try {
      dispatch(setLoading(true));
      await authService.signup(Constant.signUp, {
        ...userData,
        resendOtp: true,
      });
      dispatch(
        addNotification({
          title: "Success",
          description: "OTP resent successfully!",
          type: "success",
        })
      );
      setTimer(60);
      setOtpSent(true);
    } catch (error) {
      console.log("Failed to resend OTP. Please try again.");
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <div className="vm-login vm__otp">
      <Card className="vm-login__card vm__card-otp">
        {
          <>
            <Title level={3} className="vm__text-center vm-login__card__title">
              Enter Your OTP
            </Title>
            <Form layout="vertical" form={form} onFinish={handleVerifyOTP}>
            <Form.Item
              name="confirmationCode"
              rules={[{ required: true, message: "Please enter your OTP!" }]}
            >
              <Input.OTP
                formatter={(str) => str.replace(/\D/g, "")}
                length={6}
              />
            </Form.Item>

              <Form.Item>
                <Button type="primary" block htmlType="submit">
                  Submit
                </Button>
              </Form.Item>

              {otpSent && (
                <div style={{ textAlign: "center", margin: "16px 0" }}>
                  <Typography.Text type="secondary">
                    An email with OTP has been sent to your email address.
                  </Typography.Text>
                </div>
              )}

              <Button type="link" block onClick={handleResendOTP}>
                Resend OTP
              </Button>

              <Button
                type="link"
                onClick={() => navigate("/", { replace: true })}
                block
              >
                Back to Home
              </Button>
            </Form>
          </>
        }
      </Card>
    </div>
  );
};

export default OneTimePassword;
